import React from 'react';
import Head from 'next/head';
import { useTheme } from 'styled-components';

var mediaBreakpointHelper = function mediaBreakpointHelper(breakpoints, breakpoint) {
  var split = breakpoint.split('_');
  var shirtSize = split[0];
  var strategy = split[1] || 'gte';
  if (!breakpoints) {
    return 'all';
  }
  var keys = Object.keys(breakpoints);
  var value = breakpoints[shirtSize];
  var index = keys.indexOf(shirtSize);
  if (index < 0) {
    throw new Error("The breakpoint size '" + shirtSize + "' does not exist on the theme. Use one of " + keys.map(function (k) {
      return "'" + k + "'";
    }).join(', ') + ".");
  }
  if (['lte', 'eq', 'gte'].indexOf(strategy) < 0) {
    throw new Error("The strategy '" + strategy + "' is not valid for breakpoint '" + breakpoint + "'. Use one of '" + shirtSize + "_lte', '" + shirtSize + "_eq', '" + shirtSize + "_gte'.");
  }
  var min = '';
  if (strategy !== 'lte') {
    min = "(min-width: " + value + "px)";
  }
  var max = '';
  if (strategy !== 'gte' && index < keys.length - 1) {
    max = "(max-width: " + (breakpoints[keys[index + 1]] - 1) + "px)";
  }
  if (min || max) {
    return "" + min + (min && max ? ' and ' : '') + max;
  }
  return 'all';
};
function withPreload(Component) {
  return function WithPreloadComponent(props) {
    var src = props.src,
      srcSet = props.srcSet,
      media = props.media,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? 'eager' : _props$loading;
    // eslint-disable-next-line zillow/react-hooks/rules-of-hooks
    var theme = useTheme();
    return /*#__PURE__*/React.createElement(React.Fragment, null, loading === 'eager' && /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("link", {
      rel: "preload",
      href: src || srcSet,
      as: "image",
      media: media ? mediaBreakpointHelper(theme.constellation.breakpoints, media) : null
    })), /*#__PURE__*/React.createElement(Component, props));
  };
}

export { withPreload as default };
